export const ACCESS_TOKEN_NAME = 'jwtToken'
